module.exports = __webpack_public_path__ + "static/media/AgriX_Logo.bbb1535c.png";